var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHaemoglobinbannericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_55_42437)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6338 22.7676C43.0051 23.4357 45.3958 27.7585 47.7383 32.5703C48.9604 35.0808 50.1634 37.7128 51.0596 40.0225C51.9708 42.3711 52.5166 44.2698 52.5166 45.3672C52.5164 50.8254 48.0911 55.25 42.6328 55.25C37.1748 55.2498 32.7502 50.8252 32.75 45.3672C32.75 44.2698 33.2949 42.371 34.2061 40.0225C35.1022 37.7128 36.3061 35.0808 37.5283 32.5703C39.8719 27.7565 42.2637 23.4322 42.6338 22.7676Z",
    fill: "#D8EAF9",
    stroke: "#004276",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_55_42437",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6299 51.7467C39.1064 51.7467 36.25 48.8903 36.25 45.3668C36.25 44.9753 36.5674 44.6579 36.9589 44.6579C37.3504 44.6579 37.6678 44.9753 37.6678 45.3668C37.6678 48.1073 39.8894 50.329 42.63 50.329C43.0215 50.329 43.3389 50.6464 43.3389 51.0379C43.3388 51.4294 43.0214 51.7467 42.6299 51.7467Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.6299 51.7467C39.1064 51.7467 36.25 48.8903 36.25 45.3668C36.25 44.9753 36.5674 44.6579 36.9589 44.6579C37.3504 44.6579 37.6678 44.9753 37.6678 45.3668C37.6678 48.1073 39.8894 50.329 42.63 50.329C43.0215 50.329 43.3389 50.6464 43.3389 51.0379C43.3388 51.4294 43.0214 51.7467 42.6299 51.7467Z",
    fill: "#D8EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3389 51.0379L44.8389 51.0382V51.0379H43.3389ZM42.6299 51.7467V50.2467C39.9348 50.2467 37.75 48.0619 37.75 45.3668H36.25H34.75C34.75 49.7187 38.278 53.2467 42.6299 53.2467V51.7467ZM36.25 45.3668H37.75C37.75 45.8037 37.3958 46.1579 36.9589 46.1579V44.6579V43.1579C35.739 43.1579 34.75 44.1469 34.75 45.3668H36.25ZM36.9589 44.6579V46.1579C36.522 46.1579 36.1678 45.8037 36.1678 45.3668H37.6678H39.1678C39.1678 44.1469 38.1788 43.1579 36.9589 43.1579V44.6579ZM37.6678 45.3668H36.1678C36.1678 48.9357 39.061 51.829 42.63 51.829V50.329V48.829C40.7179 48.829 39.1678 47.2789 39.1678 45.3668H37.6678ZM42.63 50.329V51.829C42.1931 51.829 41.8389 51.4748 41.8389 51.0379H43.3389H44.8389C44.8389 49.818 43.8499 48.829 42.63 48.829V50.329ZM43.3389 51.0379L41.8389 51.0376C41.839 50.6008 42.1931 50.2467 42.6299 50.2467V51.7467V53.2467C43.8497 53.2467 44.8387 52.258 44.8389 51.0382L43.3389 51.0379Z",
    fill: "#004276",
    mask: "url(#path-4-inside-1_55_42437)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_55_42437",
    x: 0,
    y: 0,
    width: 85,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_42437"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_42437",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaemoglobinbannericon);
export default __webpack_public_path__ + "static/media/haemoglobin banner icon.91854cf403aeef11d7e9d2bedd5380b7.svg";
export { ForwardRef as ReactComponent };